import React from 'react';

const ThemeToggle = () => {
  return (
    <div>

      {/* <button
        onClick={toggleTheme}
        className="fixed top-6 right-6 z-[9999] w-14 h-14 rounded-full bg-designColor shadow-lg text-white text-xl inline-flex items-center justify-center hover:bg-opacity-80 hover:scale-110 transition-all duration-300 border-2 border-white border-opacity-20"
        aria-label="Toggle theme"
        title={isDarkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
      >
        {isDarkMode ? <BsSun className="text-2xl" /> : <BsMoon className="text-2xl" />}
      </button> */}
    </div>
  );
};

export default ThemeToggle;